import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { differenceInHours, format, parseISO } from 'date-fns';

import { TimeAgoComponent } from '../time-ago/time-ago.component';

@Component({
  standalone: true,
  selector: 'mode-date-time-display',
  imports: [CommonModule, TimeAgoComponent],
  templateUrl: 'date-time-display.component.html',
  styleUrls: ['date-time-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateTimeDisplayComponent implements OnChanges {
  @Input() timestamp: Date | string | undefined;
  showTimeAgo = false;
  time = '';

  ngOnChanges(changes: SimpleChanges): void {
    const timestamp = changes['timestamp']?.currentValue;
    this.showTimeAgo = this._showTimeAgo(timestamp);

    if (!this.showTimeAgo) {
      this.time = this._formatTime(timestamp);
    }
  }

  private _showTimeAgo(time: Date | string | undefined): boolean {
    if (!time) {
      return false;
    }
    return differenceInHours(new Date(), new Date(time)) < 48;
  }

  private _formatTime(time: Date | string | undefined): string {
    if (!time) {
      return '';
    }
    const timeAsDate = typeof time === 'string' ? parseISO(time) : time;
    return format(timeAsDate, 'MMM d, yyyy');
  }
}
